function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import VerticalTabsDefaultProps from "segments/desktop/core-components/vertical-tabs/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "/styles/colors";
const { tabs, defaultActiveTabIndex, title } = VerticalTabsDefaultProps, rest = _object_without_properties(VerticalTabsDefaultProps, [
    "tabs",
    "defaultActiveTabIndex",
    "title"
]);
const titleDefaultProps = {
    topic: {},
    title: "Streamline workflows, from operational  planning to supply chain management",
    body: "",
    textAlign: "center",
    spaceFromParagraph: "8px"
};
const asset = {
    position: "center",
    fitToContainer: true,
    image: {
        src: "/static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
    }
};
export default _object_spread_props(_object_spread({}, rest), {
    titles: [
        {
            tabsTitle: "Goals",
            tabs: [
                {
                    tabLabel: "Goal management",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "High-level project plan",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Projects overview",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Workload management",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Strategic planning",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Resource allocation",
                    asset,
                    title: titleDefaultProps
                }
            ]
        },
        {
            tabsTitle: "Projects",
            tabs: [
                {
                    tabLabel: "Project management",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Operations processes",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Request management",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Client projects",
                    asset,
                    title: titleDefaultProps
                }
            ]
        },
        {
            tabsTitle: "Tasks",
            tabs: [
                {
                    tabLabel: "Task management",
                    asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Create a workflow",
                    asset,
                    title: titleDefaultProps
                }
            ]
        }
    ],
    backgroundColor: "light-blue-video-background",
    paddingTop: 0,
    paddingBottom: 0,
    tabsPosition: positionTypes.TOP_LEFT,
    minHeight: 0,
    addTimeline: true,
    addTabIndicator: false,
    fullBackground: true,
    lineColor: Colors[WHITE_COLOR_NAME]
});
